import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// WEB3
import Web3 from 'web3';

// MODULES
import App from './App';

// STYLES
import './index.scss';

declare global {
  interface Window {
    ethereum: any;
    web3: Web3;
  }
};

export enum Sizes {
  XXL = 'XXL',
  XL = 'XL',
  L = 'L',
  M = 'M',
  S = 'S'
}

export interface GlobalState {
  chainId: number | undefined;
  connected: boolean;
  user: string | null;
  userTokensMetaData: any[];
  activeTokenId: string | undefined;
  claimedTokenIds: number[];
  nonClaimedTokens: [];
  tShirtTokens: number[];
  hoodieTokens: number[];
  sneakerTokens: number[];
  platinumTokens: number[];
  tShirtClaimedTokens: number[];
  hoodieClaimedTokens: number[];
  sneakerClaimedTokens: number[];
  platinumClaimedTokens: number[];
  tShirtNonClaimedTokens: number[];
  hoodieNonClaimedTokens: number[];
  sneakerNonClaimedTokens: number[];
  platinumNonClaimedTokens: number[];
};

export interface BurnItem {
  tokenId: string;
  size: Sizes | undefined;
}

const defaultGlobalState: GlobalState = {
  chainId: undefined,
  connected: false,
  user: null,
  userTokensMetaData: [],
  claimedTokenIds: [],
  nonClaimedTokens: [],
  tShirtTokens: [],
  hoodieTokens: [],
  sneakerTokens: [],
  platinumTokens: [],
  tShirtClaimedTokens: [],
  hoodieClaimedTokens: [],
  sneakerClaimedTokens: [],
  platinumClaimedTokens: [],
  tShirtNonClaimedTokens: [],
  hoodieNonClaimedTokens: [],
  sneakerNonClaimedTokens: [],
  platinumNonClaimedTokens: [],
  activeTokenId: undefined,
};

const GlobalStateContext = React.createContext(defaultGlobalState);
const DispatchStateContext = React.createContext<any>(undefined);

type GlobalProviderProps = { children: React.ReactNode };

const GlobalStateProvider = ({ children }: GlobalProviderProps) => {
  const [state, dispatch] = React.useReducer(
    (state: any, newValue: any) => ({ ...state, ...newValue }),
    defaultGlobalState
  );

  return (
    <GlobalStateContext.Provider value={state}>
      <DispatchStateContext.Provider value={dispatch}>
        {children}
      </DispatchStateContext.Provider>
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => [
  React.useContext(GlobalStateContext),
  React.useContext(DispatchStateContext),
];

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const registerEvents = () => {
  window.addEventListener('popstate', event => {
    window.location.href = window.location.pathname;
  }, false);
};

registerEvents();

root.render(
  <React.StrictMode>
    <GlobalStateProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GlobalStateProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


